module.exports = __webpack_public_path__ + "d1aa291727941f7e26e1989253e75244.gif";